import React from 'react';
import './PressHero.scss';

/**
 * Renders a hero with
 * @param {string} pressHeroBg - url for the hero bg
 * @param {string} pressHeroQuote - the quote content
 * @param {string} pressHeroLogo - url for the logo
 * @param {string} pressHeroLogoAlt - alt text for the logo
 * @returns {JSX.Element}
 * @constructor
 */
const PressHero = ({ pressHeroBg, pressHeroQuote, pressHeroLogo }) => (
  <div className="c-press-hero" style={{ backgroundImage: `url(${pressHeroBg})` }}>
    <div className="c-press-hero__inner">
      <div className="c-press-hero__quotation h3-right-grotesk">
        <span>“</span>
      </div>
      <div className="c-press-hero__quote-container h1-roobert">
        <h1>{pressHeroQuote}</h1>
      </div>
      <div className="c-press-hero__logo-container">
        <img src={pressHeroLogo.url} alt={pressHeroLogo.alt} />
      </div>
    </div>
  </div>
);

export default PressHero;
